import Timetable from "../components/Timetable";

export default function Entry() {
  return (
    <div className="entry">
      <h1 className="title">FINAL SCENE</h1>

      <p className="notice">
        지금부터 입장이 가능합니다.
        <br />
        스태프의 안내에 따라 입장해주세요.
      </p>

      <Timetable />
    </div>
  );
}
